export interface IBackToTop {
    scrollBehaviour : EBehaviour,
    elementClassName? : string,
    isVisible?: Boolean
}

export enum EBehaviour {
    Smooth = "smooth",
    Instant = "auto",
  }